"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FoundersExperience() {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="foundersexperience" className="bg-background ![padding:96px_16px_96px_16px]">
      <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-start">
        <div ref={headingRef} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="mb-8 overflow-hidden rounded-lg">
            <img src="https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/02/side1-1.jpg" alt="Founders of KS Luxury Renovations" className="w-full h-auto object-cover grayscale hover:grayscale-0 transition-all duration-500" />
          </div>
        </div>

        <div ref={contentRef} className={`text-left transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-100 mt-4 md:mt-24 ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="space-y-6">
            <div className="mb-12 text-left md:mb-16">
              <p className="mb-2 text-[14px] font-medium uppercase tracking-[0.1em] text-[#8b6e4c]">FOUNDERS & EXPERIENCE</p>
              <h2 className="font-display font-bold text-foreground !text-5xl">Built on International Expertise</h2>
            </div>
           <p className="text-[15px] text-foreground leading-relaxed font-sans">
  <span className="font-semibold">KS LUXURY RENOVATIONS</span> was founded by Chris and Kwstas, professionals with extensive experience in luxury construction and renovations across Australia and Cyprus.<br /><br />
  Their combined background includes:<br />
  <img src="https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/02/icon_pullet.png" alt="icon" className="inline-block mr-2 h-4 w-4 align-text-bottom" /> Diplomas in Building & Construction Management (Perth, Australia)<br />
  <img src="https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/02/icon_pullet.png" alt="icon" className="inline-block mr-2 h-4 w-4 align-text-bottom" /> Certified qualifications in wall & floor tiling<br />
  <img src="https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/02/icon_pullet.png" alt="icon" className="inline-block mr-2 h-4 w-4 align-text-bottom" /> Over 25 years of combined experience in high-end residential and commercial projects<br />
  <img src="https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/02/icon_pullet.png" alt="icon" className="inline-block mr-2 h-4 w-4 align-text-bottom" /> Proven leadership roles supervising complex construction projects in Australia<br />
  <img src="https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/02/icon_pullet.png" alt="icon" className="inline-block mr-2 h-4 w-4 align-text-bottom" /> Deep local expertise through years of renovations in Cyprus<br /><br />
  This international foundation allows us to bring global construction standards to the Cypriot market.
          </p>

          </div>
        </div>
      </div>
    </section>;
}